import { normalizePath, sanitizeOperatorId, sanitizeSearchTerm, slugify, UtilService } from '@app/shared/utils';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, UrlSegment } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AuthUser } from './core/auth/auth-frame/auth-user.model';
import { DatadogService } from './shared/services/datadog/datadog.service';
import { SdkAnalyticsService } from './shared/services/sdk-analytics/sdk-analytics.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css', '../assets/fonts/font.css']
})
export class AppComponent implements OnInit {

    public islogged = true;
    isLoading = true;
    public redirectLogin = false;
    isHomePage = false;
    language: string;

    constructor(
      private route: Router,
      private util: UtilService,
      private translate: TranslateService,
      private titleService: Title,
      private _datadogService:DatadogService,
      private _sdkAnalyticsService:SdkAnalyticsService
    ) { }

    ngOnInit() {
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        // Change page title when user changes language preference
            this.translate.get('MAINTITLE').subscribe((res: string) => {
                this.titleService.setTitle(res);
            });
        });
        this.showContent();
        this.route.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            const m_busca = event.urlAfterRedirects.match(/\/busca;searchTerm=([^;/?#]+)/);
            const m_menu = event.urlAfterRedirects.match(/\/menu;([^;/?#]+)/);
            if (m_busca && m_busca[1]){
              const searchTerm = m_busca ? decodeURIComponent(m_busca[1]) : null;
              this._sdkAnalyticsService.trackEvent( 'screen_view', {
                custom_path: '/iss/busca',
                implementation_team: 'output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente',
              });
              this._sdkAnalyticsService.trackEvent( 'search', {
                custom_path: "/iss/busca",
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                search_term: sanitizeSearchTerm(searchTerm),
                detail: "resultado-busca"
              });
            } else if (this.isMenuRoute(event.urlAfterRedirects)) {
              const detail = this.buildMenuDetailFromUrl(event.urlAfterRedirects);
              this._sdkAnalyticsService.trackEvent('screen_view', {
                custom_path: '/iss/menu',
                implementation_team: 'output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente',
                detail
              });
            } else {
              this._sdkAnalyticsService.trackEvent( 'screen_view', {
                custom_path: normalizePath(event.urlAfterRedirects),
                implementation_team: 'output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente',
              });
            }

            // Configurar o startView e setUser do datadog com base na rota atual
            if (this.authUserLogged()){
              const authUser:AuthUser = JSON.parse(localStorage.getItem('authUser'));
              const usuario:string = sanitizeOperatorId(this.getUser());//this.DDUserGerarId(this.getUser());
              this._datadogService.sendStartView(event.urlAfterRedirects, { idSessao: authUser.idSessao } );
              this._datadogService.sendSetUser(usuario, authUser.gestor + '_' + authUser.idSessao);
              this._sdkAnalyticsService.setUserProperties({ user: {
                operator_id: usuario,
                employee_id: authUser.gestor
              } });
            } else {
              this._datadogService.sendStartView(event.urlAfterRedirects );
            }
          }
        });
    }

    // tslint:disable-next-line: use-life-cycle-interface
    ngDoCheck() {
        if (this.util.isHomePageOrBrowserWarning()) {
            this.isHomePage = true;
        } else {
            this.isHomePage = false;
        }
    }

    showContent(): void {
        this.isLoading = !((sessionStorage.getItem('sessionState') === 'true' &&
            localStorage.getItem('authUser')));
        if (localStorage.getItem('authUser') == null || localStorage.getItem('authUser') == undefined) {
            this.redirectLogin = false;
            this.route.navigate(['/browser-warning']);
        } else {
            this.redirectLogin = this.islogged && !this.isLoading;
        }
    }

    getUser() {
      const token = localStorage.getItem('token') || '';
      const jsonDecoded = token && atob(token.split('.')[1]);
      return jsonDecoded && JSON.parse(jsonDecoded)['usuario'];
    }

    letraParaNumero(letra: string): number {
      if (!letra || letra.trim() === '') return 0;
      const code = letra.toUpperCase().charCodeAt(0);
      if (code < 65 || code > 90) return 0;
      return code - 64;
    }

    DDUserGerarId(nome: string): string {
      const concatenado = nome;
      let idNumerico = '';

      for (const letra of concatenado) {
        const numero = this.letraParaNumero(letra);
        idNumerico += numero.toString();
      }

      return idNumerico;
    }

    public authUserLogged(): boolean {
        return localStorage.getItem('authUser') != null && localStorage.getItem('authUser') !== undefined;
    }

  private getPrimarySegments(url: string): UrlSegment[] {
    const tree = this.route.parseUrl(url);
    const primary = tree.root.children && tree.root.children['primary'];
    return primary ? primary.segments : [];
  }

  private isMenuRoute(url: string): boolean {
    const segments = this.getPrimarySegments(url);
    return segments.some(s => s.path === 'menu');
  }

  // Captura matrix params do segmento 'menu'
  private getMenuMatrixParams(url: string): { menuName?: string; category?: string } {
    const segments = this.getPrimarySegments(url);
    const menuSeg = segments.find(s => s.path === 'menu');
    return menuSeg ? (menuSeg.parameters as any) : {};
  }

  private buildMenuDetailFromUrl(url: string): string {
    const params = this.getMenuMatrixParams(url);
    const menuName = params.menuName ? slugify(params.menuName || '') : null;
    const category = params.category ? slugify(params.category || '') : null;

    if (menuName && category) return 'menu-' + menuName + ':' + category;
    if (menuName) return 'menu-' + menuName;
    return 'menu';
  }
}
